module.exports = __webpack_public_path__ + "img/testimonial-who-4.28762a0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/testimonial-who-4.png
// module id = ./assets/img/testimonial-who-4.png
// module chunks = 2 3 4 5 6